import { common_api_pageheaders_url, photoblog_api_v1_flagged_counts_url } from 'mk/urls/functions';
import { MAIL_DETAIL_FETCH_SUCCESS } from 'mk2/apps/mail/containers/MailDetail/MailDetail.actions';
import {
    PAGEHEADER_FETCH_FLAGGED_COUNTS_TRIGGER,
    PAGEHEADER_LOAD,
    pageHeaderFetch,
    pageHeaderFetchFlaggedCountsApi,
    PageHeaderFetchFlaggedCountsTriggerAction,
    PageHeaderFetchRequestAction,
    pageHeaderLoad,
} from 'mk2/containers/PageHeader/PageHeader.action';
import { normalizeError, XHRAction } from 'mk2/helpers/api';
import { getLogger } from 'mk2/logger';
import { PageHeaderUserData } from 'mk2/schemas';
import { JAM_NOTIFICATION, JamNotificationAction } from 'mk2/services/jam.actions';
import { all, call, put, takeLatest, throttle } from 'redux-saga/effects';

const logger = getLogger('containers/PageHeader.sagas');

interface ApiResponsePageHeaders {
    body: PageHeaderUserData;
}

function* userbarJamNotification({ }: JamNotificationAction) {
    yield put(pageHeaderLoad());
}

function* fetchPageHeaders({ xhr }: PageHeaderFetchRequestAction & XHRAction) {
    yield put(pageHeaderFetch.request());

    try {
        const response: ApiResponsePageHeaders = yield call(
            () => xhr.get(common_api_pageheaders_url()),
        );

        yield put(pageHeaderFetch.success(
            response.body,
        ));
    } catch (error) {
        logger.error(error);
        yield put(pageHeaderFetch.failure(normalizeError(error)));
    }
}

interface ApiResponseFetchFlaggedCounts {
    body: {
        flagged_count: number;
        flagged_groups_count: number;
    };
}

function* fetchFlaggedCounts({ xhr }: PageHeaderFetchFlaggedCountsTriggerAction & XHRAction) {
    yield put(pageHeaderFetchFlaggedCountsApi.request());

    try {
        const response: ApiResponseFetchFlaggedCounts = yield call(
            () => xhr.get(photoblog_api_v1_flagged_counts_url()),
        );
        yield put(pageHeaderFetchFlaggedCountsApi.success(
            response.body.flagged_count,
            response.body.flagged_groups_count,
            null,
        ));
    } catch (error) {
        logger.error(error);
        yield put(pageHeaderFetchFlaggedCountsApi.failure(normalizeError(error)));
    }
}

export default function* root() {
    yield all([
        // Reload also when user loads mail detail so that unreadMails is refreshed
        takeLatest([ PAGEHEADER_LOAD, MAIL_DETAIL_FETCH_SUCCESS ], fetchPageHeaders),
        takeLatest(PAGEHEADER_FETCH_FLAGGED_COUNTS_TRIGGER, fetchFlaggedCounts),

        // run once - then wait 30s for next reload
        throttle(
            30 * 1000,
            (action: JamNotificationAction) => action.type === JAM_NOTIFICATION && action.channel.startsWith('userbar:'),
            userbarJamNotification,
        ),
    ]);
}
